import type { IAddress } from "@/types/address";
import type { IUser } from "@/types/users";
import { UserRole } from "@/types/users";
import type { IServiceArea } from "@/types/common";

export type IContractor = IUser & {
  userId: number;
  role: UserRole.Contractor;
  enabled: boolean;
  address: IAddress;
  contractingCompanyId: number;
  licenceNumber: string;
  serviceAreas: IServiceArea[];
} & IContractorProfessionalDetails;

export type IContractorProfessionalDetails = {
  yearsOfExperience: number;
  expertise: ContractorExpertise[];
};

export type IContractorServiceArea = IServiceArea;

export enum ContractorExpertise {
  Plumbing = "Plumbing",
  Painting = "Painting",
  Carpentry = "Carpentry",
  Electrical = "Electrical",
  Roofing = "Roofing",
}

export const isContractor = (user: IUser): user is IContractor => {
  return user.role === UserRole.Contractor;
};
